import React from "react"
import { connect } from "react-redux"
import { Content, Page } from "./Page"
import { HeadingTwo, Button, Paragraph, } from "buoy-core"
import styled from "styled-components"
import UserDetailsForm from "../../account/components/UserDetailsForm"
import Link from "../../common/components/Link"
import { ButtonRow } from "./ButtonRow"
import { submitAccountInfoAndShowModal } from "../actions"
import { initProfiles } from "../../account/actions"
import { pushRoute } from "../../common/route"
import { responsive } from "../../common/styledHelpers"
import { teleMedicineAccountState } from "../../account/components/UserDetailsFormConfig"
import TelemedicineModal from "./TelemedicineModal"
import tracker from "../../common/tracker"

// KAN-4851 revisit

const LoginLink = () => (
  <Link
    size="bodyMain"
    onClick={() => pushRoute(`/login?next=${window.location.pathname}`, true)}
  >
    {" "}
    Log in
  </Link>
)

const Heading = styled(HeadingTwo)`
  margin-bottom: 12px;
  line-height: 1.17;
  ${responsive("font-size", "32px", "30px")};
`

const ResponsiveParagraph = styled(Paragraph)`
  ${responsive("margin-bottom", "40px", "32px")};
`
// props.providerName is a placeholder, it will be changed to something that can be used when the props passed are defined.
const Telemedicine = props => {
  return (
    <Page>
      <Content>
        <TelemedicineModal />
        <Heading alignLeft>Create an account.</Heading>
        {props.loggedIn ? (
          <ResponsiveParagraph>
            Once complete, we will connect you to {props.providerName}
            online providers
          </ResponsiveParagraph>
        ) : (
          <Paragraph margin={"0 0 12px"}>
            Create your Buoy Health account to continue to virtual visit.
          </Paragraph>
        )}
        {!props.loggedIn && (
          <ResponsiveParagraph>
            Already have an account?
            <LoginLink />
          </ResponsiveParagraph>
        )}
        <UserDetailsForm {...props} address dirty payForm />
        <ButtonRow>
          <Button disabled={!props.canSubmit} onClick={props.onSubmit}>
            Continue to visit
          </Button>
        </ButtonRow>
      </Content>
    </Page>
  )
}

// Remove when user profiles is merged and we can re-factor
// form a bit
const keyReplacements = {
  first_name: "first",
  last_name: "last",
}

class TelemedicineContainer extends React.Component {
  state = {
    ...teleMedicineAccountState,
  }

  componentDidMount() {
    tracker.paymentAccountPageLoaded()
    if (this.props.loggedIn) {
      return this.props.initProfiles().then(this.populateStateWithProfile())
    } else {
      this.populateStateWithProfile()
    }
  }

  populateStateWithProfile = () => {
    // Handle populating state with profile in redux.
    if (this.props.profile) {
      const newState = { ...this.state }

      Object.keys(this.props.profile).forEach(key => {
        const replacement = keyReplacements[key]

        if (key === "year" && !this.props.profile.year) {
          newState.year.value =
            new Date().getFullYear() - this.props.profile.age
          newState.year.valid = true
        } else if (newState[replacement || key] && this.props.profile[key]) {
          newState[replacement || key].value = this.props.profile[key]
          newState[replacement || key].valid = true
        }
      })
      this.setState(newState)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profile.id !== this.props.profile.id) {
      this.populateStateWithProfile()
    }
  }

  onBlur = field => e => {
    this.setState({
      [field]: {
        ...this.state[field],
        isActive: false,
      },
    })
  }

  onFocus = field => e => {
    this.setState({
      [field]: {
        ...this.state[field],
        isActive: true,
        edited: true,
      },
    })
  }

  onDropdownClick = field => e => {
    this.setState({
      [field]: {
        ...this.state[field],
        edited: true,
      },
    })
  }

  onChangeInput = field => e => {
    let val = e.target.value
    let isValid = false

    if (field === "phone") {
      val = ("" + val).replace(/\D/g, "")
      if (val.length > 10) return
    }

    isValid = this.state[field].validate(val)

    this.setState({
      [field]: {
        ...this.state[field],
        value: val,
        edited: true,
        valid: isValid,
      },
    })
  }

  onChangeDropdown = field => value => {
    let isValid = this.state[field].validate(value)
    this.setState({
      [field]: {
        ...this.state[field],
        value: value,
        edited: true,
        valid: isValid,
      },
    })
  }

  matchPasswords = () => {
    return this.props.loggedIn
      ? true
      : this.state.password.value === this.state.passwordConfirm.value
  }

  validateForm = () => {
    let ignoreFields = ["email", "password", "passwordConfirm"]

    return !Object.entries(this.state).find(f => {
      if (this.props.loggedIn && ignoreFields.includes(f[0])) return false
      return f[1].valid === false
    })
  }

  canSubmit = () => {
    if (!this.props.loggedIn && !this.matchPasswords()) return false
    return this.validateForm()
  }

  onSubmit = () => {
    this.props.submitAccountInfo(this.state)
  }

  render() {
    return (
      <Telemedicine
        selected={this.props.profile}
        {...this.props}
        {...this.state}
        canSubmit={this.canSubmit()}
        onSubmit={this.onSubmit}
        onDropdownClick={this.onDropdownClick}
        onChangePassword={this.onChangePassword}
        onChangeDropdown={this.onChangeDropdown}
        onChangeInput={this.onChangeInput}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    )
  }
}

const mapStateToProps = state => ({
  loggedIn: !state.auth.isAnonymous,
  profile: state.account.profiles.find(p => p.isself) || {},
})

const mapDispatchToProps = dispatch => ({
  initProfiles: () => dispatch(initProfiles()),
  submitAccountInfo: (fields) => dispatch(submitAccountInfoAndShowModal(fields))
})

const ConnectedTelemedicineContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TelemedicineContainer)

export { ConnectedTelemedicineContainer as default, Telemedicine }



// WEBPACK FOOTER //
// ./assets/payment/components/TeleMedicineForm.js